<mat-dialog-content class="modal-content-update">
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Descargar Resumen</h2>
    <form [formGroup]="resumeForm" class="space-y-6">


        <div class="mb-4">
            <mat-label class="text-sm font-semibold text-gray-700">Selecciona los resúmenes a descargar:</mat-label>
            <div class="grid grid-cols-2 gap-2 mt-2">
                <mat-checkbox formControlName="includePreSales">
                    Resumen Preventa
                </mat-checkbox>
                <mat-checkbox formControlName="includeDeliveries">
                    Resumen Entrega
                </mat-checkbox>
                <mat-checkbox formControlName="includePayments">
                    Resumen Cobranza
                </mat-checkbox>
                <mat-checkbox formControlName="includeEffectiveness">
                    Resumen de Efectividad de Visita
                </mat-checkbox>
            </div>
        </div>

        <div>
            <mat-label class="text-sm font-semibold text-gray-700">Agregar resumen de visitas a:</mat-label>
            <mat-radio-group formControlName="showVisitTableMode" class="flex flex-row gap-4 mt-2">
                <mat-radio-button [value]="'none'">
                    <div class="flex items-center">
                        <span class="ml-1">Ninguna</span>
                    </div>
                </mat-radio-button>
                <mat-radio-button [value]="'first'">
                    <div class="flex items-center">
                        <span class="ml-1">Primer hoja</span>
                    </div>
                </mat-radio-button>
                <mat-radio-button [value]="'all'">
                    <div class="flex items-center">
                        <span class="ml-1">Todas las hojas</span>
                    </div>
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="modal-actions flex justify-between">
    
    <button mat-button (click)="onCancel()">
        Cancelar
    </button>
    
    <div class="flex gap-3">
        
        <button 
            [disabled]="resumeForm.invalid || loading" 
            mat-raised-button 
            color="primary" 
            (click)="onDownloadExcel()">
            <mat-icon *ngIf="loading" class="animate-spin mr-2">refresh</mat-icon>
            Descargar Excel
        </button>
        
        <button 
            [disabled]="resumeForm.invalid || loading" 
            mat-raised-button 
            color="primary" 
            (click)="onDownload()">
            <mat-icon *ngIf="loading" class="animate-spin mr-2">refresh</mat-icon>
            Descargar PDF
        </button>
        
    </div>
</mat-dialog-actions>